import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { App } from '@/App'
import { AntdProvider } from '@/components/AntdProvider'
import ErrorBoundary from '@/components/ErrorBoundary'
import '@/i18n'
import '@/styles/tailwind.css'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AntdProvider>
      <ErrorBoundary>
        <App />
      </ErrorBoundary>
    </AntdProvider>
  </StrictMode>,
)
